import React from 'react';
import {Box, Typography} from '@mui/material';
import {BuilderPot, BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {ParentPlanRow} from '../CreateBuilder/BuilderSourceDestination/ParentPlanRow';
import {
  getSummary,
  getSummaryParts,
} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {ModifySourceSubplan} from './ModifySourceSubplan';

interface ModifySourceParentProps {
  pot: BuilderPot;
  selectedId: string | undefined;
  sameReview?: boolean;
  handleChange: (id: string) => void;
}

export const ModifySourceParent: React.FC<ModifySourceParentProps> = ({
  pot,
  selectedId,
  sameReview,
  handleChange,
}) => {
  const dentistChildren: BuilderPot_dentistChildren[] = pot.dentistChildren ?? [];
  const hasChildren = dentistChildren.length > 0;
  const isChildSelected = hasChildren && dentistChildren.some((c) => c.id === selectedId);

  if (hasChildren) {
    const {label, currentValue} = getSummaryParts(pot);
    return (
      <ParentPlanRow
        pot={pot}
        isSelected={isChildSelected}
        sameReview={sameReview}
        validationLevel={isChildSelected ? 'valid' : 'nothing'}
        summaryChildren={
          <>
            <Typography mb={0} variant="body1" sx={{fontWeight: 600}}>
              {label}
            </Typography>
            {currentValue && (
              <Typography
                variant="body2"
                mb={0}
                sx={{fontWeight: 600, ml: 2, whiteSpace: 'nowrap'}}
              >
                {currentValue}
              </Typography>
            )}
          </>
        }
      >
        {dentistChildren.map((child) => (
          <ModifySourceSubplan
            key={child.id}
            subPlan={child}
            isSelected={selectedId === child.id}
            handleChange={() => handleChange(child.id)}
          />
        ))}
      </ParentPlanRow>
    );
  }

  const isSelected = selectedId === pot.id;
  return (
    <ParentPlanRow pot={pot} isSelected={isSelected} sameReview={sameReview}>
      <PlanAccordionShell
        expanded={false}
        isSelected={isSelected}
        isSoleParent
        validationLevel="nothing"
        sameReview={sameReview}
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={pot.id}
              isSelected={isSelected}
              handleChange={() => handleChange(pot.id)}
            />
            <Box display="flex" flexDirection="row">
              {getSummary(pot)}
            </Box>
          </>
        }
      />
    </ParentPlanRow>
  );
};
